const DisableTryItOutPlugin = function (system) {
    return {
        statePlugins: {
            spec: {
                wrapSelectors: {
                    allowTryItOutFor: () => () => {
                        const serves = system.specSelectors.specJson().get('servers')
                        return serves !== undefined && serves.size !== 0
                    }
                }
            }
        },
        wrapComponents: {
            authorizeBtn: (Original, { React }) => (props) => {
                const serves = system.specSelectors.specJson().get('servers')
                return serves !== undefined && serves.size !== 0 ? React.createElement(Original, props) : null
            },
        }
    }
}


const customAuthorizationPlugin = () => {
    const currentDomain = window.location.origin;
    return {
        statePlugins: {
            auth: {
                wrapActions: {
                    authorizeApplication: (originalAction, system) => {
                        const scopeSeparator = " "
                        const { authActions } = system
                        return (auth) => {
                            const { schema, scopes, name, clientId, clientSecret } = auth
                            const headers = {
                            }
                            const form = {
                                grant_type: "client_credentials",
                                scope: scopes.join(scopeSeparator),
                                client_id: clientId,
                                client_secret: clientSecret
                            }
                            return authActions.authorizeRequest({ body: buildFormData(form), name, url: `${currentDomain}/oauth2/token`, auth, headers })
                        }
                    }
                }
            }
        }

    }
}


export const buildFormData = (data) => {
    let formArr = []

    for (let name in data) {
        let val = data[name]
        if (val !== undefined && val !== "") {
            formArr.push([name, "=", encodeURIComponent(val).replace(/%20/g, "+")].join(""))
        }
    }
    return formArr.join("&")
}

export const authorizeRequest = (data) => ({ fn, getConfigs, authActions, errActions, oas3Selectors, specSelectors, authSelectors }) => {
    let { body, query = {}, headers = {}, name, url, auth } = data

    let { additionalQueryStringParams } = authSelectors.getConfigs() || {}

    let parsedUrl

    if (specSelectors.isOAS3()) {
        let finalServerUrl = oas3Selectors.serverEffectiveValue(oas3Selectors.selectedServer())
        parsedUrl = parseUrl(url, finalServerUrl, true)
    } else {
        parsedUrl = parseUrl(url, specSelectors.url(), true)
    }

    if (typeof additionalQueryStringParams === "object") {
        parsedUrl.query = Object.assign({}, parsedUrl.query, additionalQueryStringParams)
    }

    const fetchUrl = parsedUrl.toString()

    let _headers = Object.assign({
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Requested-With": "XMLHttpRequest"
    }, headers)

    fn.fetch({
        url: fetchUrl,
        method: "post",
        headers: _headers,
        query: query,
        body: body,
        requestInterceptor: getConfigs().requestInterceptor,
        responseInterceptor: getConfigs().responseInterceptor
    })
        .then(function (response) {
            let token = JSON.parse(response.data)
            let error = token && (token.error || "")
            let parseError = token && (token.parseError || "")

            if (!response.ok) {
                errActions.newAuthErr({
                    authId: name,
                    level: "error",
                    source: "auth",
                    message: response.statusText
                })
                return
            }

            if (error || parseError) {
                errActions.newAuthErr({
                    authId: name,
                    level: "error",
                    source: "auth",
                    message: JSON.stringify(token)
                })
                return
            }

            authActions.authorizeOauth2WithPersistOption({ auth, token })
        })
        .catch(e => {
            let err = new Error(e)
            let message = err.message
            // swagger-js wraps the response (if available) into the e.response property;
            // investigate to check whether there are more details on why the authorization
            // request failed (according to RFC 6479).
            // See also https://github.com/swagger-api/swagger-ui/issues/4048
            if (e.response && e.response.data) {
                const errData = e.response.data
                try {
                    const jsonResponse = typeof errData === "string" ? JSON.parse(errData) : errData
                    if (jsonResponse.error)
                        message += `, error: ${jsonResponse.error}`
                    if (jsonResponse.error_description)
                        message += `, description: ${jsonResponse.error_description}`
                } catch (jsonError) {
                    // Ignore
                }
            }
            errActions.newAuthErr({
                authId: name,
                level: "error",
                source: "auth",
                message: message
            })
        })
}


export function initializeSwagger(swaggerContainerDivId, swaggerUrl) {
    $('#' + swaggerContainerDivId).ready(function () {
        SwaggerUIBundle({
            plugins: [
                DisableTryItOutPlugin,
                customAuthorizationPlugin
            ],
            url: swaggerUrl,
            dom_id: '#' + swaggerContainerDivId,
            presets: [
                SwaggerUIBundle.presets.apis,
                SwaggerUIBundle.SwaggerUIStandalonePreset
            ],
            showCommonExtensions: true,
            deepLinking: false,
            layout: "BaseLayout",
            onComplete: () => completeCustomization(swaggerContainerDivId)
        });
    });
}


export function completeCustomization(swaggerContainerDivId) {
    var row = $("<div class='row'></div>");
    var abstractDiv = $("<div class='container abstract'></div>");

    var linksSection = $("<div class='links'></div>")
        .append($("#" + swaggerContainerDivId + " .swagger-ui .information-container.wrapper .info .info__tos"))
        .append($("#" + swaggerContainerDivId + " .swagger-ui .information-container.wrapper .info .info__contact"))
        .append($("#" + swaggerContainerDivId + " .swagger-ui .information-container.wrapper .info .info__license"))
        .append($("#" + swaggerContainerDivId + " .swagger-ui .information-container.wrapper .info .info__extdocs.link"));

    $(abstractDiv).append($("#" + swaggerContainerDivId + " .swagger-ui .information-container.wrapper .info .description"));
    $(abstractDiv)
        .append(linksSection);


    $(".scheme-container .auth-wrapper .btn").addClass("btn-primary");

    $(row).append($(".scheme-container"));

    $(row).append(abstractDiv);

    $("#" + swaggerContainerDivId + " .swagger-ui .information-container.wrapper .info").append(row);
}